<template>
  <div>
    <h1 class="mb-4 text-3xl font-bold">
      Pembayaran
    </h1>
    <div class="flex justify-between items-center mb-4">
      <search-filter
        v-model="form.search"
        placeholder="Cari nama atau NIM mahasiswa..."
        :show-dropdown="false"
        class="mr-4 w-full max-w-md"
        @reset="reset" />
      <a
        :href="urlExportExcel"
        class="btn-green"
        as="button"
        title="Download data dalam format .xlsx"><i
          class="fas fa-file-excel" /> Export Excel</a>
    </div>
    <div class="overflow-x-auto bg-white rounded-md shadow">
      <table class="w-full whitespace-nowrap">
        <tr class="font-bold text-left">
          <th class="px-6 pt-6 pb-4 text-left">
            Nama Mahasiswa
          </th>
          <th class="px-6 pt-6 pb-4 text-left">
            NIM
          </th>
          <th class="px-6 pt-6 pb-4 text-left">
            Nama Kampus
          </th>
          <th class="px-6 pt-6 pb-4 text-left">
            Tanggal Pembayaran
          </th>
          <th class="px-6 pt-6 pb-4 text-right">
            Nominal
          </th>
          <th class="px-6 pt-6 pb-4 text-left">
            Status Bayar
          </th>
        </tr>
        <tr
          v-for="row in payments.data"
          :key="row.id"
          class="focus-within:bg-gray-100 hover:bg-gray-100">
          <td class="py-4 px-6 text-left border-t">
            <inertia-link class="focus:text-indigo-500" :href="route('payment.edit', row.id)">
              {{ row.mahasiswa_name }}
            </inertia-link>
          </td>
          <td class="py-4 px-6 text-left border-t">
            <inertia-link class="focus:text-indigo-500" :href="route('payment.edit', row.id)">
              {{ row.mahasiswa_nim }}
            </inertia-link>
          </td>
          <td class="py-4 px-6 text-left border-t">
            <inertia-link class="focus:text-indigo-500" :href="route('payment.edit', row.id)">
              {{ row.universitas }}
            </inertia-link>
          </td>
          <td class="py-4 px-6 text-left border-t">
            <inertia-link class="focus:text-indigo-500" :href="route('payment.edit', row.id)">
              {{ row.payment_date }}
            </inertia-link>
          </td>
          <td class="py-4 px-6 text-right border-t">
            <inertia-link class="focus:text-indigo-500" :href="route('payment.edit', row.id)">
              {{ formatNumber(row.payment_amount) }}
            </inertia-link>
          </td>
          <td class="py-4 px-6 text-left border-t">
            <inertia-link class="focus:text-indigo-500" :href="route('payment.edit', row.id)">
              {{ row.payment_status }}
            </inertia-link>
          </td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="payments.links" />
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import { router, Link } from '@inertiajs/vue2'

export default {
    metaInfo: { title: 'KRS' },
    components: {
        Pagination,
        SearchFilter,
        'inertia-link': Link,
    },
    layout: Layout,
    props: {
        filters: Object,
        payments: Object,
    },
    data () {
        return {
            form: {
                search: this.filters.search,
            },
        }
    },
    computed: {
        urlExportExcel () {
            return (
                '/payment/export?' +
                new URLSearchParams(pickBy(this.form)).toString()
            )
        },
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function () {
                router.get(this.route('payment.index'), pickBy(this.form), {
                    preserveState: true,
                })
            }, 150),
        },
    },
    methods: {
        reset () {
            this.form = mapValues(this.form, () => null)
        },
        is_verified_icon (val) {
            return val ? 'fas fa-check-circle' : 'fas fa-times-circle'
        },
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID') : '0'
        },
    },
}
</script>
